import type { SchoolTranslate } from "../useSchoolLocal";
import * as yup from "yup";

export const talkToAdvisorValidation = (t: SchoolTranslate) => {
  const requiredMessage = t("connect.errors.required");
  const invalidEmail = t("connect.errors.invalidEmail");

  return yup.object().shape({
    full_name: yup.string().required(requiredMessage),
    work_email: yup.string().email(invalidEmail).required(requiredMessage),
    job_title: yup.string().required(requiredMessage),
    school_name: yup.string().required(requiredMessage),
    phone_number: yup.string().required(requiredMessage),
    country: yup.string().required(requiredMessage),
    explore_with_numuw: yup.string().required(requiredMessage),
  });
};

export type TalkToAdvisorValues = {
  full_name: string;
  work_email: string;
  job_title: string;
  school_name: string;
  phone_number: string;
  country: string;
  explore_with_numuw: string;
  additional_info: string;
};

export type Keys = keyof TalkToAdvisorValues;

export const talkToAdvisorInitialValues: TalkToAdvisorValues = {
  full_name: "",
  work_email: "",
  job_title: "",
  school_name: "",
  phone_number: "",
  country: "",
  explore_with_numuw: "",
  additional_info: "",
};
